import apiClient from './api';

async function fetchStatistics(filters = {}) {
  const response = await apiClient.get('/get-statistics', {
    params: filters
  });
  return response; 
}

export { fetchStatistics };

